import { h, Component } from 'preact';
import { ICorporateMentionProps, IEmptyState } from '../sgwt-mini-footer.types';

export default class CorporateMention extends Component<ICorporateMentionProps, IEmptyState> {
  private year: number;

  constructor(props: ICorporateMentionProps) {
    super(props);
    this.year = new Date().getFullYear();
  }

  render(props: ICorporateMentionProps): JSX.Element {
    return (
      <li>
        &copy; {props.label} {this.year}
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/sgwt-mini-footer/components/CorporateMention.tsx